import { TFunction } from 'i18next'
import { IUSER_NOTIFICATION_TYPES } from './types'

const TYPE_TO_KEY: Partial<Record<IUSER_NOTIFICATION_TYPES, string>> = {
  [IUSER_NOTIFICATION_TYPES.PLAY_COMMENT_ADDED]: 'notifications.plays.commentAdded',
  [IUSER_NOTIFICATION_TYPES.PLAY_COMMENT_REPLY]: 'notifications.plays.commentReply',
  [IUSER_NOTIFICATION_TYPES.PLAY_COMMENT_MENTION]: 'notifications.plays.commentMention',
  [IUSER_NOTIFICATION_TYPES.PLAY_COMMENT_REPLY_MENTION]: 'notifications.plays.commentReplyMention',
  [IUSER_NOTIFICATION_TYPES.PLAY_COMMENT_THREAD]: 'notifications.plays.commentThread',
  [IUSER_NOTIFICATION_TYPES.CHAT_TAG]: 'notifications.plays.chatTag',
  [IUSER_NOTIFICATION_TYPES.CHAT_MESSAGE_EDITED]: 'notifications.plays.chatEdited',
}

class NotificationMessageFactory {
  static getMessage(
    notificationType: IUSER_NOTIFICATION_TYPES,
    userName: string,
    businessName: string | undefined,
    t: TFunction
  ): string {
    const userPart = businessName
      ? t('notifications.userOfBusiness', { user: userName, business: businessName })
      : userName
    const key = TYPE_TO_KEY[notificationType] ?? 'notifications.plays.commentAdded'
    return t(key, { user: userPart })
  }
}

export default NotificationMessageFactory
